(function() {
  if (window.__cxCardClickThrough) return;
  window.__cxCardClickThrough = true;

  document.addEventListener('click', function(event) {
    var card = event.target.closest('.product-card-wrapper');
    if (!card || event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.target.closest('a, button, input, select, textarea, summary, label, form, modal-opener, product-form, .wishlist-engine, .cx-wishlist-card, .quick-add, .card__badge, [role="button"]')) return;

    var link = card.querySelector('a.full-unstyled-link[href*="/products/"]');
    if (link && link.href) window.location.href = link.href;
  });
})();
